export const showNotification= (message,actionWord,actionType) => ({ type: 'SHOW_NOTIFICATION',message,actionWord,actionType})
export const hideNotification= () => ({ type: 'HIDE_NOTIFICATION'})


// WEBPACK FOOTER //
// ./src/actions/notifications.js